import { useRouter } from 'next/router';
import { useLocalStorage } from 'react-use';
import toast from 'react-hot-toast';
import { useEffect } from 'react';

function SignedOutPage() {
    const [signOutRedirectUrl] = useLocalStorage<string>('sign-out-redirect');
    const router = useRouter();

    useEffect(() => {
        toast('Uspešno ste se odjavili!');

        if (signOutRedirectUrl) {
            router.push(signOutRedirectUrl);
        } else {
            router.push('/');
        }
    }, []);

    return null;
}

export default SignedOutPage;
